import { Grid, Typography } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { useStaticState } from "@material-ui/pickers";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { withFirebase } from "../Firebase";
import NewUserMessageDialog from "../RescuerSignUp/NewUserMessageDialog";
import OutOfDate from "../RescuerSignUp/OutOfDate";
import SignOut from "../RescuerSignUp/SignOut";
import SignUpFormLoading from "../SignUpFormLoading";
import FormBody from "./FormBody";

const UserSignUp = (props) => {
  const { firebase } = props;
  const { t } = useTranslation();
  const params = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [isUserCreated, setIsUserCreated] = useState(false);
  const [openSignUpModal, setOpenSignUpModal] = useState(false);
  const [isSigningUp, setIsSigningUp] = useState(false);
  const [onCreateMessage, setOnCreateMessage] = useState("second");
  const [waittingAccCompleted, setwaittingAccCompleted] = useState(false);
  const [isformAvailable, setIsformAvailable] = useState(false);
  const [formConfig, setFormConfig] = useState({});

  const signUp = (rescuerData) => {
    const { email, surname, name, psw } = rescuerData;
    const info = {
      name: name,
      surname: surname,
      autorizacion: true,
      comunicaciones: true,
      email: email,
    };
    const sgpfc = {
      formId: params.key,
      email: email,
      userType: "viewer",
    };
    console.table(info);
    console.table(sgpfc);
    firebase.signUpUser(email, psw).then((UserCredential) => {
      setIsUserCreated(true);
      UserCredential.user.updateProfile({ displayName: name });
      firebase
        .user(UserCredential.user.uid)
        .update({
          info: info,
          sgpfc: sgpfc,
        })
        .then(() => {
          setIsSigningUp(false);
          setIsUserCreated(true);
          setOnCreateMessage({
            msg: "auth/user-success",
            success: true,
          });
          setOpenSignUpModal(true);
        })
        .catch((err) => {
          setIsUserCreated(true);
          setIsSigningUp(false);
          setOnCreateMessage({ msg: err.code, success: false });
          setOpenSignUpModal(true);
        });
    });
  };

  useEffect(() => {
    firebase
      .RDNUsersFormsRef(params.key)
      .once("value")
      .then((snap) => {
        const data = snap.val();
        setFormConfig(data);
        setTimeout(() => {
          setIsformAvailable(!!data);
          setIsLoading(false);
        }, 3500);
      });
  }, []);

  if (isLoading) {
    return <SignUpFormLoading />;
  } else if (!isformAvailable) {
    return <OutOfDate />;
  } else if (!!!firebase.currentUser() || isUserCreated) {
    return (
      <Grid container spacing={4} justify="center" style={{ backgroundColor: grey[50] }}>
        <Grid item xs={12} md={10} lg={7} xl={6} style={{ marginTop: 32 }} container justify="center">
          <Grid item xs={12} container justify="center">
            <Typography
              variant="h3"
              color="secondary"
              style={{
                marginTop: 32,
                marginBottom: 32,
                fontWeight: 800,
                textAlign: "center",
              }}
            >
              {/* revisar la forma de calcular el número de rescatadores */}
              {t("totalRescuersSignUp", { n: 203 })}
            </Typography>
          </Grid>
          <FormBody createRescuer={signUp} />
        </Grid>
        <NewUserMessageDialog
          open={openSignUpModal}
          onCreateRescuerMessage={onCreateMessage}
          waittingForAccountCompleted={waittingAccCompleted}
          setwaittingForAccountCompleted={setwaittingAccCompleted}
          setIsSigningUp={setIsSigningUp}
          isSigningUp={isSigningUp}
        />
      </Grid>
    );
  } else {
    return <SignOut />;
  }
};

export default withFirebase(UserSignUp);
